import { Downloader } from "@shared";

export const VERSION_CODENAME = "Supernova";

export const DOWNLOADER_NAME = {
  [Downloader.RealDebrid]: "Real-Debrid",
  [Downloader.Torrent]: "Torrent",
  [Downloader.Gofile]: "Gofile",
  [Downloader.PixelDrain]: "PixelDrain",
  [Downloader.Qiwi]: "Qiwi",
  [Downloader.Datanodes]: "Datanodes",
  [Downloader.Mediafire]: "Mediafire",
  [Downloader.TorBox]: "TorBox",
  [Downloader.Hydra]: "Nimbus",
};

export const MAX_MINUTES_TO_SHOW_IN_PLAYTIME = 120;

export const THEME_WEB_STORE_URL = "https://hydrathemes.shop";
